import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import {
  MatError,
  MatFormField,
  MatLabel,
  MatPrefix,
  MatSuffix,
} from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, Subscriber } from 'rxjs';
import { CommonApiService } from '../CommonController/common-api-service';
import { UserManagementApiService } from '../CommonController/userManagement-api-service';
import { SharedValidators } from '../shared/validators/shared-validators';

@Component({
  selector: 'app-profile-page',
  templateUrl: './profile-page.component.html',
  styleUrls: ['./profile-page.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMatSelectSearchModule,
    MatIcon,
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
    MatSuffix,
    MatPrefix,
    NgxPaginationModule,
  ],
})
export class ProfilePageComponent implements OnInit {
  showCurrentPassword = false;
  showNewPassword = false;

  userPermissions = [];
  loggedInUserId = '';
  permissionList = [];
  email = '';

  roleId = '';
  myimage;
  userProfileForm: FormGroup;
  userChangePasswordForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    public userManagementApiService: UserManagementApiService,
    public commonApiService: CommonApiService,
    public dialog: MatDialog,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit() {
    this.setProfileForm();
    this.checkPermission();
    this.fetchDataById(this.loggedInUserId);
  }

  checkPermission() {
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
  }

  setProfileForm() {
    this.userProfileForm = this.formBuilder.group({
      firstName: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
        SharedValidators.nonNumericNoSpecialChars,
      ]),
      lastName: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
        SharedValidators.nonNumericNoSpecialChars,
      ]),
      mobileNumber: new FormControl('', [
        SharedValidators.mobileNumberValidation,
      ]),
      userEmail: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
        SharedValidators.validEmail,
      ]),
      userRole: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
      ]),
      userRefId: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
      ]),
      country: new FormControl('', [SharedValidators.requiredAndNoEmptySpaces]),
      state: new FormControl('', [SharedValidators.requiredAndNoEmptySpaces]),
      adminName: new FormControl('', SharedValidators.requiredAndNoEmptySpaces),
      status: new FormControl('', SharedValidators.requiredAndNoEmptySpaces),
      Image: '',
    });
    this.email = sessionStorage.getItem('loggedInUserEmail');
    this.userChangePasswordForm = this.formBuilder.group({
      currentPassword: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
        SharedValidators.minLengthRequired(8),
      ]),
      newPassword: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
        SharedValidators.minLengthRequired(8),
      ]),
    });
    this.myimage = '../../assets/profile.png';
  }

  fetchDataById(id) {
    this.spinner.show();
    this.userManagementApiService.getSingleUser(id).subscribe((res) => {
      const data = res.data;
      if (res.status) {
        this.userProfileForm = this.formBuilder.group({
          firstName: new FormControl(data.firstName, [
            SharedValidators.requiredAndNoEmptySpaces,
            SharedValidators.nonNumericNoSpecialChars,
          ]),
          lastName: new FormControl(data.lastName, [
            SharedValidators.requiredAndNoEmptySpaces,
            SharedValidators.nonNumericNoSpecialChars,
          ]),
          mobileNumber: new FormControl(data.mobileNumber, [
            SharedValidators.mobileNumberValidation,
          ]),
          userEmail: new FormControl(data.userEmail, [
            SharedValidators.requiredAndNoEmptySpaces,
            SharedValidators.validEmail,
          ]),
          userRole: new FormControl(
            data.roleName,
            SharedValidators.requiredAndNoEmptySpaces
          ),
          state: new FormControl(data.state, [
            SharedValidators.requiredAndNoEmptySpaces,
          ]),
          country: new FormControl(data.country, [
            SharedValidators.requiredAndNoEmptySpaces,
          ]),
          status: new FormControl(
            data.status,
            SharedValidators.requiredAndNoEmptySpaces
          ),
          adminName: new FormControl(
            data.adminName ? data.adminName : '--',
            SharedValidators.requiredAndNoEmptySpaces
          ),
          Image: '',
          userRefId: data.userRefId,
          id: id,
          updatedAt: new Date(),
        });
        this.roleId = data.roleId;
        this.myimage = data.image ? data.image : '../../assets/profile.png';
        this.spinner.hide();
      } else {
        this.spinner.hide();
        this.commonApiService.openSnackbar(res.message);
      }
    });
  }

  validateFormUpdate() {
    if (this.userProfileForm.invalid) {
      SharedValidators.markAllAsTouched(this.userProfileForm);
      return;
    } else {
      this.updateUser();
    }
  }

  updateUser() {
    this.spinner.show();
    const payload = this.userProfileForm.value;
    sessionStorage.setItem('userName', payload.firstName);
    sessionStorage.setItem('email', payload.userEmail);
    sessionStorage.setItem(
      'userFullName',
      `${payload.firstName} ${payload.lastName}`
    );
    payload.image = this.myimage;
    payload.roleId = this.roleId;
    this.userManagementApiService.updateUser(payload).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res.status) {
          this.commonApiService.openSnackbar(res.message);
        } else {
          this.commonApiService.openSnackbar(res.message);
        }
        this.spinner.hide();
        this.ngOnInit();
      },
      error: (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.commonApiService.openSnackbar(ERROR.error.message);
      },
    });
  }

  validateFormPasswordUpdate() {
    if (this.userChangePasswordForm.invalid) {
      SharedValidators.markAllAsTouched(this.userChangePasswordForm);
      return;
    } else {
      this.ChangePassword();
    }
  }

  ChangePassword() {
    if (confirm('Are you Sure?')) {
      if (
        this.userChangePasswordForm.value.currentPassword ===
        this.userChangePasswordForm.value.newPassword
      ) {
        this.commonApiService.openSnackbar(
          'Current Password cannot be same as New Password.'
        );
      } else {
        const payload = {
          currentPassword: this.userChangePasswordForm.value.currentPassword,
          newPassword: this.userChangePasswordForm.value.newPassword,
          userEmail: this.email,
        };
        this.userManagementApiService.userChangePassword(payload).subscribe({
          next: (res) => {
            if (res.status) {
              this.closeModal();
              this.commonApiService.openSnackbar(res.message);
            } else {
              this.closeModal();
              this.commonApiService.openSnackbar(res.message);
            }
          },
          error: (ERROR: HttpErrorResponse) => {
            const example = ERROR.error.message;
            this.commonApiService.openSnackbar(example);
          },
        });
      }
    }
  }

  closeModal() {
    document
      .getElementById('changePassword')
      .parentElement.classList.remove('active');
    this.userChangePasswordForm = this.formBuilder.group({
      currentPassword: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
        SharedValidators.minLengthRequired(8),
      ]),
      newPassword: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
        SharedValidators.minLengthRequired(8),
      ]),
    });
  }

  changePass() {
    document
      .getElementById('changePassword')
      .parentElement.classList.add('active');
  }

  onChange($event: Event) {
    const file = ($event.target as HTMLInputElement).files[0];
    const fileName = file.name;
    if (file.size >= 2 * 1024 * 1024) {
      this.commonApiService.openSnackbar('Max upload size allowed is 2mb');
    } else {
      const ext = fileName.substring(fileName.lastIndexOf('.') + 1);
      if (
        ext.toLowerCase() === 'png' ||
        ext.toLowerCase() === 'jpg' ||
        ext.toLowerCase() === 'jpeg'
      ) {
        this.convertToBase64(file);
      }
    }
  }

  convertToBase64(file: File) {
    const observable = new Observable((subscriber: Subscriber<string>) => {
      this.readFile(file, subscriber);
    });
    observable.subscribe((d) => {
      this.myimage = d;
    });
  }

  readFile(file: File, subscriber: Subscriber<string | null>) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      const result = fileReader.result;
      if (typeof result === 'string') {
        // Type guard
        subscriber.next(result);
      } else {
        subscriber.error(new Error('File could not be read as a string.'));
      }
      subscriber.complete();
    };

    fileReader.onerror = (error) => {
      subscriber.error(error);
      subscriber.complete();
    };
  }

  navigateBack() {
    this.commonApiService.back();
  }
}
